<template>
  <div style="margin-top: 15px">
    {{ $t("message.title.selectTemplate") }}
    <el-input v-model="search_data" :placeholder="$t('message.placeholder.input')" style="width: 42%; margin-left: 10px"
      @keyup.enter.native="searchSimple" size="small">
    </el-input>
    <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px" @click="searchSimple">{{
      $t("message.button.search") }}</el-button>
    <!-- <el-button
      type="success"
      icon="el-icon-folder-checked"
      size="small"
      style="margin-left: 10px"
      @click="checkData"
      >{{ $t("message.button.submit") }}</el-button
    > -->
    <div class="table">
      <vxe-grid ref="xGrid" v-bind="addTableList" @cell-dblclick="dbClick">
        <template v-slot:toolbar>
          <vxe-toolbar custom>
            <template v-slot:buttons>
              <vxe-form> </vxe-form>
            </template>
          </vxe-toolbar>
        </template>
        <!-- <template v-for="col in cols" >
          <vxe-table-column :field="col.prop" :title="col.label" :key="col.prop">
          </vxe-table-column>
        </template> -->
      </vxe-grid>
      <el-pagination small v-if="paginationShow" class="pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords">
      </el-pagination>
    </div>
  </div>
</template>


<script>
import axios from "axios";
export default {
  data() {
    return {
      search_data: "",
      select_value: 301,
      input: "",
      select: "",
      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      totalRecords: "",
      paginationShow: false,
      options: [
        {
          value: "301",
          label: "项目",
        },
      ],
      searchVal: "",
      get_change_info: "",
      tableColumn: [],
      tableShow: false,
      oldTableValue: [],
      tableData: [],
      cols: [],
      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],
        data: [],
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          // activeMethod: this.activeRowMethod,
          showStatus: true,
        },
      },
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchClick()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchClick()
      // const { data: res } = await this.$http.get(loadTableUrl);
    },
    dbClick(row) {
      console.log(row.row);
      //let arr = [row.row];
      let project = row.row;
      this.$emit("listDbClick", project);
    },
    checkData() {
      let removeRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(removeRow);
      if (removeRow.length == 0) return false;
      this.$emit("listDbClick", removeRow);
    },
    searchSimple() {
      // this.cols = [];
      var obj_get = {
        //获取url参数
        baseClassId: this.select_value,
        value: this.search_data,
        size: this.pageSize,
        page: this.currentPage,
      };
      // if (obj_get.value == "") {
      //   this.$message({
      //     showClose: true,
      //     message: this.$t("message.warning.searchErr_01"),
      //     type: "warning",
      //   });
      // }
      this.addTableList.data = [];
      axios.get(`/ppm/project/searchProjectTemplete${this.params(obj_get)}`).then((res) => {
        if (res.data.code == 200) {
          this.totalRecords = res.data.object.table.totalRecords
          if (this.totalRecords == 0) {
            this.$message({
              showClose: true,
              message: this.$t("message.warning.searchErr_02"),
              type: "warning",
            });
            this.addTableList.data = [];
            return
          }
          let projectTempls = res.data.object.table.columnInfo.names;
          // console.log(1111,items);
          this.cols = projectTempls.map((project, index) => {
            return { field: index, title: project };
          });
          this.addTableList.columns = [...this.cols];

          projectTempls = res.data.object.table.rows;
          // console.log(items);
          let arr = [];
          for (var i = 0; i < projectTempls.length; i++) {
            var rols_ = {};
            rols_.authTag = projectTempls[i].authTag;
            //console.log(this.rols[i].cells);
            for (var j = 0; j < projectTempls[0].cells.length; j++) {
              if (projectTempls[i].cells[j] == null) {
                rols_[j] = "";
              } else {
                rols_[j] = projectTempls[i].cells[j].val;
                rols_["projectSubClass"] = projectTempls[i].objSubClass;
                rols_["projectClass"] = projectTempls[i].objClass;
                rols_["projectId"] = projectTempls[i].objId;
              }
            }
            arr.push(rols_);
          }


          // console.log(arr);
          this.addTableList.data = arr;
        }
      });
      //console.log(res);
    },
  },
  created() {
    //this.select_value = this.options[0].value;
  },
};
</script>

<style scoped>
.table {
  /* margin-top:15px; */
  height: 530px;
  overflow: auto;
}

.el-select .el-input {
  width: 90px !important;
}


.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>